import React from 'react';
import { string, oneOfType, number } from 'prop-types';
import styled, { css } from 'styled-components';
import withTranslation from '../../../hoc/withTranslation';
import { get, isArray } from 'lodash';

const tagTypes = {
    'pendiente-picking': '#a4c735',
    'picked': '#1fa02e',
    'no-stock': '#db5959',
    'substitute': '#4eaccd',
    'partial-picking': '#D5C638',
    'free-picking': '#B0649D',
    'added': '#1fa02e',
    'picking-pending': '#64908A',
    'available': '#848484',
    'unavailable': '#f38630',
    'removed': '#db5959',
    'error': '#db5959',
    'reserved': '#848484',
    'in_picking': '#1fa02e',
    'paused': '#1fa02e',
    'pickeo_for_invoicing': '#1fa02e',
    'invoiced': '#1fa02e',
    'pending': '#848484',
    'pending_audit_pre': '#FB5C97',
    'audit_rejected_pre': '#FB5C97',
    'pending_audit_post': '#FB5C97',
    'audit_rejected': '#FB5C97',
    'pending_cancellation': '#F38630',
    'cancelled': '#F38630',
    '34': '#DB5959',
    'loose': '#333333',
    'unpicked-store': '#db5959',
    'invoice_error': '#FF0000',
    'invoicing': '#FF0000',
    'found': '#1fa02e',
    'not-found': '#db5959',
    'found-partial': '#F38630',
    '21': '#F38630'
};

const OrderStatusTagContainer = styled.div`
  border-radius: ${({ borderRadius = 12 }) => borderRadius}px;
  border: solid 1px ${({ borderColor, tagType, backgroundColor }) => tagTypes[tagType] || borderColor || backgroundColor || '#a4c735'};
  padding: 5px 8px;
  ${({ margin, mT = '7', mR = '5', mB = '7', mL = '5', mX, mY }) => `
    margin: ${margin || mY || mT}px ${margin || mX || mR}px ${margin || mY || mB}px ${margin || mX || mL}px;
  `}
  color:  ${props => tagTypes[props.tagType] || props.color || '#a4c735'};
  font-weight: 600;
  box-sizing: content-box;
  min-width: max-content;
  display: flex;
  justify-content: center;
  font-size: 11px;
  line-height: 11px;

  ${({ backgroundColor }) => backgroundColor && css`background-color: ${backgroundColor};`}

  ${({ fill, color, tagType }) => fill && `
    background: ${fill};
  `}

  ${({ fit }) => fit && css`
    width: fit-content;
  `}
`;

const OrderStatusTag = (props) => {
    const { status, messageIndex, dot } = props;
    const _resolveText = () => isArray(status) ? get(status, messageIndex, status) : status;
    return <OrderStatusTagContainer {...props}>{ `${ dot ? '• ' : ''}${_resolveText() || 'N/A'}` }</OrderStatusTagContainer>;
};

OrderStatusTag.propTypes = {
    status: string,
    messageIndex: oneOfType([string, number])
};

OrderStatusTag.defaultProps = {
    status: '',
    messageIndex: 0
};

export default withTranslation(OrderStatusTag, ['status']);
